module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-big-light-green-027d3b9741eacb593293e10d86c47904.svg";